import classNames from 'classnames';
import React from 'react';

function DeleteCartPromptViewTemplate ({ helpers }) {

	const { showInlineError, showErrorElement, promptText } = helpers;

	const promptModalClassNames = classNames('promptModal', !showErrorElement && 'noInlineError');

	return (
		<div id="deleteCartModal" className={promptModalClassNames}>
			{showInlineError && <div className="error" />}
			<p>
				{promptText && (
					<>
						{promptText}
					</>
				)}
				{!promptText && <>Are you sure you want to delete this?</>}
			</p>
			<div className="actionButtons">
				<button type="button" className="btnCancel calloutBtn small style3">
					Cancel
				</button>
				{' '}
				<button type="button" className="btnDelete calloutBtn small">
					Delete
				</button>
			</div>
		</div>
	);

}

export default DeleteCartPromptViewTemplate;
